/* eslint-disable security/detect-object-injection */
import profileUtils from '../repositories/profileUtils';



let sortJSON = (data, key, way)=>{
    return data.sort(function (a, b) {
        let x = a[key];
        let y = b[key];
        let expA = x > y ? 1 : 0;
        let expB = x < y ? 1 : 0;
        let expAscending = x < y ? -1 : expA;
        let expDescending = x > y ? -1 : expB;
        if (way === '123') {
            return expAscending;
        } else if (way === '321') {
            return expDescending;
        }
        return -1;
    });
}

let parseDate = (dateToParse) =>{
    let year = dateToParse.slice(0, 4);
    let month = dateToParse.slice(4, 6);
    let day = dateToParse.slice(6, 8);
    return month + '-' + day + '-' + year;
}
let showTracking = (trackURL) =>{
    window.open(trackURL, '_blank').focus();
    profileUtils.publishAnalytics('orderHistory', 'TrackingNumberClick', 'click');
}
let onLangsPageChange = ()=>{
    document.body.scrollTop = 0; // For Chrome, Safari and Opera
    document.documentElement.scrollTop = 0; // For IE and Firefox
}

let isItemNotAvailable = (status)=> {
    const prodNotAvailableStatuses = ['09', '05', '02'];
    return prodNotAvailableStatuses.some(s => s === status);
}

let formatDateString = (stringDate) =>{
    let date = new Date(stringDate);
    let year = date.getFullYear().toString();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) {
        month = '0' + month.toString();
    }
    if (day < 10) {
        day = '0' + day.toString();
    }
    return year + '-' + month + '-' + day;
}

const String2Regex = str => {
    // Main regex
    const main = str.match(/\/(.+)\/.*/)[1]

    // Regex options
    const options = str.match(/\/.+\/(.*)/)[1]

    // Return compiled regex
    return new RegExp(main, options);
}

export default {
    sortJSON:sortJSON,
    parseDate:parseDate,
    showTracking:showTracking,
    onLangsPageChange:onLangsPageChange,
    isItemNotAvailable:isItemNotAvailable,
    formatDateString:formatDateString,
    String2Regex:String2Regex
};
